// mainCalendar.jsx
import FullCalendar from '@fullcalendar/react';
import { useState, useEffect, useRef, useCallback } from 'react';
import Sidebar from '../support/Sidebar';
import Responsive from '../../Responsive/Responsive';
import HeaderFilter from '../support/HeaderFilter';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import "../../../assets/demo/css/bootstrap.min.css";

//01-09 Start

import {
    Login,
    ZoneList,
    Calendar_api,
    BASE_URL,
    fetchWithTokenRefresh2,
    FetchCalendarWithZone,
    MakeBooking_API,
    CancelBooking_API,
    Calendar_API,
    BookingCancelNewWeekRefresh,
    // Calendar_APIforBooking
} from '../support/apiUtils';
import CalendarLogic from './CalendarRefresh';
import { useTranslation } from 'react-i18next'

import filterIcon from "../../../assets/images/icons/filterIcon.svg"
import Close from "../../../assets/images/icons/close.svg";
import OrangeStar from "../../../assets/images/icons/orange-star.svg";
import GreenMap from "../../../assets/images/icons/green-map.svg";
import EditSquare from "../../../assets/images/icons/edit-square.svg";
import MapOrange from "../../../assets/images/icons/map-orange.svg";
import TimeIcon from "../../../assets/images/icons/time.svg";
import UserIcon from "../../../assets/images/icons/user-name.svg"
import Deskbooking from "../../../assets/images/desk-booking.png"
import cancelBooking from "../../../assets/images/icons/black-cancel-icon.svg"
import notification from "../../../assets/images/icons/notification.svg"
import profileImg from "../../../assets/images/profileImg.jpg"
import edit from "../../../assets/images/icons/edit.svg"
import logoutwhite from "../../../assets/images/icons/logout-white.svg"
import Profile from "../../../assets/images/profile.png"
import ProfileLocation from "../../../assets/images/icons/profile-location.svg"
import FillStar from "../../../assets/images/icons/fill-star.svg"
import GrayStar from "../../../assets/images/icons/gray-star.svg"
import BlackClose from "../../../assets/images/icons/black-close.svg"
import LoaderFull from "../../../assets/images/loading.gif"
//import NotificationPanel from './Notification';
import PlusButton from "../../../assets/images/icons/white-plus.svg"
import Deleteicon from "../../../assets/images/icons/trash.svg"
import ScheduleMeetingicon from "../../../assets/images/icons/schedule-meeting.svg"

const SESSION = {
    selectedZoneIDInCalendarScreen: 'selectedZoneIDInCalendarScreen',
    SelectedTranslation: 'selectedTranslation',
};

const Calendar = () => {
    const { t } = useTranslation()
    const [loadingWeeks, setLoadingWeeks] = useState({});
    const [calendarEl, setCalendarEl] = useState(null);
    const [weeklyPercentages, setWeeklyPercentages] = useState([]);
    const [selectedDate, setSelectedDate] = useState('');
    const [selectedDay, setSelectedDay] = useState(null);
    const [displayMonth, setDisplayMonth] = useState(null);
    const [displayYear, setDisplayYear] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [selectedYear, setSelectedYear] = useState(null);
    const [clickedFullDay, setClickedFullDay] = useState(false);

    const [currentDate, setCurrentDate] = useState(new Date()); // Represents today's date for logic
    const [events, setEvents] = useState([
        { id: '1', title: 'Spot 3467TY - All day', start: '2024-12-09', status: 'checked-out' },
        { id: '2', title: 'Spot WER 234 - 10:50 - 12:00', start: '2024-12-10', status: 'available' },
        { id: '3', title: 'Spot WER 234 - 10:50 - 12:00', start: '2024-12-10', status: 'available' },
        { id: '4', title: 'Spot WER 234 - 10:50 - 12:00', start: '2024-12-10', status: 'available' },
        { id: '5', title: 'Spot WER 234 - 10:50 - 12:00', start: '2024-12-10', status: 'available' },
    ]);
    const employeeOptions = [
        "Michael Furey",
        "John Warde",
        "Mathieu Pegeot",
        "Daire O Brien",
        "Angela Hernandez",
        "New User",
        "One more Added"
    ];
    const [showModal, setShowModal] = useState(false);
    const [weekData, setWeekData] = useState({}); // Stores fetched weekly booking schedules

    const [isLoading, setIsLoading] = useState(false); // For initial full calendar load
    const [availabilityDays, setAvailabilityDays] = useState([]);
    const [startbookingData, setStartBookingData] = useState([]);
    const [bookingSpotData, setBookingSpotData] = useState([]); // This appears to be initial/default booking data before week-specific fetches
    const [calendarRenderKey, setCalendarRenderKey] = useState(0); // To force re-render FullCalendar if needed

    const calendarRef = useRef(null);
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [bookingToCancelDate, setBookingToCancelDate] = useState(null); // Full date object
    const [showBookingModal, setShowBookingModal] = useState(false);
    const [bookingCreateDate, setBookingCreateDate] = useState(null); // Full date object

    const [showJoinQueueModal, setShowJoinQueueModal] = useState(false);
    const [joinQueueDate, setJoinQueueDate] = useState(null); // Full date object
    const [showLeaveQueueModal, setShowLeaveQueueModal] = useState(false);
    const [leaveQueueDate, setLeaveQueueDate] = useState(null); // Full date object

    const [recordsData, setRecordsData] = useState(null);
    const [teamLeadFlag, setTeamLeadFlag] = useState(0);
    const [isQueue, setIsQueue] = useState(0);
    const [preBookingQuestion, setPreBookingQuestion] = useState("");
    const [mapAvailable, setMapAvailable] = useState(); // New state for map availability
    const [mapAvailableType, setMapAvailableType] = useState(); // New state for map availability
    const [creditInfoJSX, setCreditInfoJSX] = useState(null); // Set to null initially, render only if available

    const [mainCurrentDate, setMainCurrentDate] = useState("");
    const [selectedZoneName, setSelectedZoneName] = useState('Loading Zones...');
    const [selectedCalendarZoneId, setSelectedCalendarZoneId] = useState(0); // Holds the ID of the currently selected zone

    const [zoneList, setZoneList] = useState([]);
    const [UserFirstName, setUserFirstName] = useState("");
    const [cancelBookingSpotId, setCancelBookingSpotId] = useState(null);

    const [showScheduleMeetingModal, setShowScheduleMeetingModal] = useState(false);

    const [userZoneCreditValue, setUserZoneCreditValue] = useState();
    const [UserzoneCreditBalance, setUserZoneCreditBalance] = useState();

    // const [showBookingModal, setShowBookingModal] = useState(false);
    const [showMeetingModal, setShowMeetingModal] = useState(false);
    const [selectedBookingDate, setSelectedBookingDate] = useState(null);
    const [selectedCancelDate, setSelectedCancelDate] = useState(null);
    const [selectedMeetingDate, setSelectedMeetingDate] = useState(null);
    const [calendarWeeks, setCalendarWeeks] = useState({}); // Cache for weeks already fetched
    const [loadingDates, setLoadingDates] = useState([]); // Dates currently loading bookings
    const [isMonthly, setIsMonthly] = useState(false);

    const [open, setOpen] = useState(false);
    const rootRef = useRef(null);
    const headerTitle = t("react_hi").replace("%s", UserFirstName);

    const toggle = (e) => {
        e.stopPropagation();                // prevent immediate close
        if (zoneList?.length > 0) setOpen((v) => !v);
    };

    const onSelect = (zone) => {
        // Build a fake <select>-like event
        const fakeEvent = {
            target: {
                value: zone.Id.toString(),
                options: [{ text: zone.ZoneName }],
                selectedIndex: 0,
            },
        };

        handleZoneChange(fakeEvent);
        setOpen(false);
    };

    const timeOutTime = 3000;
    // const getGuId = () => localStorage.getItem("guId");
    const getGuId = () => sessionStorage.getItem("guId");
    const day = currentDate.getDate();
    const month = currentDate.getMonth() + 1;
    const year = currentDate.getFullYear();
    const TodayDate = year + "-" + month + "-" + day;

    const today = new Date(); // Use a local 'today' for comparison
    const todayMidnight = new Date(today.getFullYear(), today.getMonth(), today.getDate());

    // useEffect(() => {
    //     setWeeklyPercentages(generateUniquePercentages(7, 10, 30));
    //     const intervalId = setInterval(() => {
    //         setCurrentDate(new Date()); // Keep 'currentDate' updated for accurate 'today' calculations
    //     }, 1000);

    //     Calendar_Logic();

    //     return () => clearInterval(intervalId);
    // }, []);

    useEffect(() => {
    setWeeklyPercentages(generateUniquePercentages(7, 10, 30));

    // Remove the 1-second interval entirely (causes popup flicker)
    setCurrentDate(new Date());

    Calendar_Logic();
}, []);


    useEffect(() => {
        const handleOutsideClick = (event) => {
            // Check if the click is outside the dropdown
            if (rootRef.current && !rootRef.current.contains(event.target)) {
                setOpen(false); // Close the dropdown
            }
        };

        // Add the event listener to the document
        document.addEventListener('mousedown', handleOutsideClick);

        // Clean up the event listener when the component unmounts
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [rootRef]);

    //     useEffect(() => {
    //   console.log("bookingSpotData actually updated in state:", bookingSpotData);
    // }, [bookingSpotData]);

    // Helper to format date strings consistently for keys and comparisons
    function formatDateString(dateString) {
        if (!dateString) { // Handle cases where dateString might be null or undefined
            return null; // Or new Date() to return today's date, depending on your logic
        }

        const date = new Date(dateString);

        // Crucial: Check if the created Date object is valid
        if (isNaN(date.getTime())) {
            // It's an "Invalid Date". Log an error or handle it.
            console.error("Could not parse date string:", dateString);
            return null; // Or throw an error, or return a default date
        }
        return date;
    }

    //     const performCalendarApiCall = async (bookingDateStr, zoneId, SpotId) => {
    //     console.log("performCalendarApiCall()", { bookingDateStr, zoneId, SpotId });
    //   setIsLoading(true);
    //   try {
    //     const { calendarData, error } = await FetchCalendarWithZone(zoneId, SpotId);

    //     if (error) {
    //       console.error("Error in performCalendarApiCall:", error);
    //       setBookingSpotData([]);
    //       return;
    //     }

    //     if (calendarData?.Data?.ResponseCode === 200) {
    //       setRecordsData(calendarData?.Data?.Records);

    //       if (Array.isArray(calendarData.Data.Records.Schedule)) {
    //         const freshSchedule = [...calendarData.Data.Records.Schedule];
    //         setBookingSpotData(freshSchedule);

    //         console.log("API returned schedule:", freshSchedule);
    //       } else {
    //         setBookingSpotData([]);
    //       }
    //     } else {
    //       console.error(
    //         "Calendar API response code not 200:",
    //         calendarData?.Data?.ResponseCode
    //       );
    //       setBookingSpotData([]);
    //     }
    //   } catch (err) {
    //     console.error("Error performing calendar API call:", err);
    //     setBookingSpotData([]);
    //   } finally {
    //     setIsLoading(false);
    //   }
    // };

    //////////////////////////////////////////////////////////////////

    //last workoing performCalendarApiCall
    const performCalendarApiCall = async (bookingDateStr, zoneId) => {
        console.log("performCalendarApiCall()", { bookingDateStr, zoneId });
        try {
            const { calendarData, error } = await BookingCancelNewWeekRefresh(bookingDateStr, zoneId);

            if (error) {
                console.error("Error in performCalendarApiCall:", error);
                return;
            }

            if (calendarData?.Data?.ResponseCode === 200) {
                setRecordsData(calendarData?.Data?.Records);

                if (Array.isArray(calendarData.Data.Records.Schedule)) {
                    const freshSchedule = [...calendarData.Data.Records.Schedule];
                    setBookingSpotData((prevData) => {
                        if (!Array.isArray(prevData)) return freshSchedule;
                        const updated = prevData.map((week) => {
                            if (week.BookingDate === bookingDateStr) {
                                return { ...week, ...freshSchedule.find(s => s.BookingDate === week.BookingDate) };
                            }
                            return week;
                        });
                        const exists = updated.some(w => w.BookingDate === bookingDateStr);
                        if (!exists) {
                            return [...updated, ...freshSchedule];
                        }

                        return updated;
                    });
                    console.log("API returned schedule for this week only:", freshSchedule);
                }
            } else {
                console.error(
                    "Calendar API response code not 200:",
                    calendarData?.Data?.ResponseCode
                );
            }
        } catch (err) {
            console.error("Error performing calendar API call:", err);
        } finally {
            // setLoadingDates(false);
        }
    };


    const Calendar_Logic = useCallback(async () => {
        setIsLoading(true);
        try {
            // const token = localStorage.getItem("accessToken");
            const token = sessionStorage.getItem("accessToken");
            let loginSuccess = false;

            const loginResponse = await Login();

            if (loginResponse && loginResponse.Data?.ResponseCode === 200) {
                loginSuccess = true;
                console.log("Login API call successful.");
            } else {
                throw new Error("Login failed: Invalid response from server.");
            }
            // if (token) {
            //     console.log("Token found in localStorage. user is logged in.");
            //     loginSuccess = true;
            // } else {
            //     console.log("No token found in localStorage. Attempting login...");
            //     const loginResponse = await Login();
            //     if (loginResponse && loginResponse.Data?.ResponseCode === 200) {
            //         loginSuccess = true;
            //         console.log("Login API call successful.");
            //     } else {
            //         throw new Error("Login failed: Invalid response from server.");
            //     }
            // }

            if (!loginSuccess) {
                throw new Error("Authentication failed. Cannot proceed with calendar logic.");
            }

            const { zoneData, calendarData, error } = await FetchCalendarWithZone();
            if (error) {
                console.error("Error during initial FetchCalendarWithZone:", error);
                setZoneList([]);
                setSelectedCalendarZoneId(0);
                setSelectedZoneName("Error loading zones");
                return;
            }

            const fetchedZoneList = zoneData?.Data?.Records?.ZoneList ?? [];
            setZoneList(fetchedZoneList);

            let defaultZoneToSelect = fetchedZoneList.find((z) => z.DefaultId === 1);
            if (!defaultZoneToSelect && fetchedZoneList.length > 0) {
                defaultZoneToSelect = fetchedZoneList[0];
            }

            if (defaultZoneToSelect) {
                setSelectedCalendarZoneId(defaultZoneToSelect.Id);
                setSelectedZoneName(defaultZoneToSelect.ZoneName);
            } else {
                setSelectedCalendarZoneId(0);
                setSelectedZoneName("No Zones Available");
            }

            if (calendarData?.Data?.ResponseCode === 200) {
                setRecordsData(calendarData?.Data?.Records);
                // setRecordsData(calendarData?.Data?.Records);
                setUserFirstName(calendarData?.Data?.Records?.FirstName ?? "");
                setMainCurrentDate(calendarData?.Data?.Records?.ZoneCurrentDate ?? "");
                setTeamLeadFlag(calendarData?.Data?.Records?.TeamLeadFlag ?? 0);
                setIsQueue(calendarData?.Data?.Records?.QueueUser ?? 0);
                setPreBookingQuestion(calendarData?.Data?.Records?.PreBookingQuestion ?? "");
                setMapAvailable(calendarData?.Data?.Records?.MapExist);
                setMapAvailableType(calendarData?.Data?.Records?.MapType);
                console.log("setRecordsData", calendarData?.Data?.Records);
                if (Array.isArray(calendarData.Data.Records.Schedule)) {
                    setBookingSpotData([...calendarData.Data.Records.Schedule]);
                    console.log("Initial bookingSpotData:", calendarData.Data.Records.Schedule);
                } else {
                    setBookingSpotData([]);
                }
            } else {
                console.error("Initial Calendar_API response code not 200:", calendarData?.Data?.ResponseCode);
                setBookingSpotData([]);
            }
        } catch (err) {
            console.error("Error fetching initial data in Calendar_Logic:", err);
            setBookingSpotData([]);
            setZoneList([]);
            setSelectedCalendarZoneId(0);
            setSelectedZoneName("Error loading zones");
        } finally {
            setIsLoading(false);
        }
    }, []);

//     const Calendar_Logic_for_Login = useCallback(async () => {
//     setIsLoading(true);

//     try {
//         // Read tokens saved by LoginEvent
//         const accessToken = sessionStorage.getItem("accessToken");
//         const guid = sessionStorage.getItem("guId");

//         // const accessToken = () => authMemory.getAccessToken();
//         // const guid = () => authMemory.getGuId();//reactmemory version

//         // If user NOT logged in, redirect to Login screen
//         if (!accessToken || !guid) {
//             console.warn("No login token found. Redirecting to login...");
//             navigate("/");   // redirect to login
//             return;
//         }

//         console.log("User authenticated. Running Calendar logic...");

//         // Fetch Calendar + Zones
//         console.log("++++++++++++++++++++++++++++++++++++++++");
//         const { zoneData, calendarData, error } = await FetchCalendarWithZone();
//         console.log("----------------------------------------");

//         if (error) {
//             console.error("Error during initial FetchCalendarWithZone:", error);
//             setZoneList([]);
//             setSelectedCalendarZoneId(0);
//             setSelectedZoneName("Error loading zones");
//             return;
//         }

//         // Process ZONE list
//         const fetchedZoneList = zoneData?.Data?.Records?.ZoneList ?? [];
//         setZoneList(fetchedZoneList);

//         let defaultZone = fetchedZoneList.find((z) => z.DefaultId === 1);
//         if (!defaultZone && fetchedZoneList.length > 0) {
//             defaultZone = fetchedZoneList[0];
//         }

//         if (defaultZone) {
//             setSelectedCalendarZoneId(defaultZone.Id);
//             setSelectedZoneName(defaultZone.ZoneName);
//         } else {
//             setSelectedCalendarZoneId(0);
//             setSelectedZoneName("No Zones Available");
//         }

//         // Process Calendar Data
//         if (calendarData?.Data?.ResponseCode === 200) {
//             const rec = calendarData.Data.Records;

//             setRecordsData(rec);
//             setUserFirstName(rec?.FirstName ?? "");
//             setMainCurrentDate(rec?.ZoneCurrentDate ?? "");
//             setTeamLeadFlag(rec?.TeamLeadFlag ?? 0);
//             setIsQueue(rec?.QueueUser ?? 0);
//             setPreBookingQuestion(rec?.PreBookingQuestion ?? "");
//             setMapAvailable(rec?.MapExist);
//             setMapAvailableType(rec?.MapType);

//             if (Array.isArray(rec?.Schedule)) {
//                 setBookingSpotData([...rec.Schedule]);
//                 console.log("Initial bookingSpotData:", rec.Schedule);
//             } else {
//                 setBookingSpotData([]);
//             }
//         } else {
//             console.error("Calendar API Response not 200:", calendarData?.Data?.ResponseCode);
//             setBookingSpotData([]);
//         }
//     } catch (err) {
//         console.error("Error inside Calendar_Logic:", err);
//         setBookingSpotData([]);
//         setZoneList([]);
//         setSelectedCalendarZoneId(0);
//         setSelectedZoneName("Error loading zones");
//     } finally {
//         setIsLoading(false);
//     }
// }, []);
    //     const Calendar_Logic = useCallback(async () => {
    //         setIsLoading(true);

    //         try {
    //             // --- 1. Check for token in localStorage ---
    //             const token = localStorage.getItem("accessToken");
    //             let loginSuccess = false;

    //             if (token) {
    //                 console.log("Token found in localStorage. user is logged in.");
    //                 loginSuccess = true;
    //             } else {
    //                 console.log("No token found in localStorage. Attempting login...");
    //                 const loginResponse = await Login();
    //                 if (loginResponse && loginResponse.Data?.ResponseCode === 200) {
    //                     loginSuccess = true;
    //                     console.log("Login API call successful.");
    //                 } else {
    //                     throw new Error("Login failed: Invalid response from server or non-200 code.");
    //                 }
    //             }

    //             if (!loginSuccess) {
    //                 throw new Error("Authentication failed. Cannot proceed with calendar logic.");
    //             }
    //             // try {
    //             //     const loginResponse = await Login();
    //             //     if (!loginResponse || loginResponse.Data?.ResponseCode !== 200) {
    //             //         throw new Error("Login failed: Invalid response from server or non-200 code");
    //             //     }

    //             // Initial fetch which also gets the ZoneList and then the Calendar data
    //             const { zoneData, calendarData, error } = await FetchCalendarWithZone(); // No zoneId passed initially

    //             if (error) {
    //                 console.error("Error during initial FetchCalendarWithZone:", error);
    //                 setZoneList([]);
    //                 setSelectedCalendarZoneId(0);
    //                 setSelectedZoneName('Error loading zones');
    //                 setCreditInfoJSX(null);
    //                 localStorage.removeItem(SESSION.selectedZoneIDInCalendarScreen);
    //                 return;
    //             }


    //             // ...
    // const fetchedZoneList = zoneData?.Data?.Records?.ZoneList ?? [];
    // setZoneList(fetchedZoneList);

    // const storedZoneIdString = localStorage.getItem(SESSION.selectedZoneIDInCalendarScreen);
    // const storedZoneId = storedZoneIdString ? parseInt(storedZoneIdString, 10) : null;

    // let defaultZoneToSelect = null;

    // // 1. Try to find the previously stored zone
    // // if (storedZoneId !== null) {
    // //   defaultZoneToSelect = fetchedZoneList.find((zone) => zone.Id === storedZoneId);
    // //   console.log("defa", defaultZoneToSelect);
    // // }

    // // 2. If no stored zone or not found, try to find the default zone
    // if (!defaultZoneToSelect) {
    //   defaultZoneToSelect = fetchedZoneList.find(zone => zone.DefaultId === 1);
    //   console.log("defa", defaultZoneToSelect);
    // }

    // // 3. If no default zone found, fall back to the first zone in the list (if any)
    // if (!defaultZoneToSelect && fetchedZoneList.length > 0) {
    //   defaultZoneToSelect = fetchedZoneList[0];
    // }

    // // 4. Update state based on the selected zone
    // if (defaultZoneToSelect) {
    //   setSelectedCalendarZoneId(defaultZoneToSelect.Id);
    //   setSelectedZoneName(defaultZoneToSelect.ZoneName);
    //   localStorage.setItem(SESSION.selectedZoneIDInCalendarScreen, defaultZoneToSelect.Id.toString());
    // } else {
    //   // Handle the case where no zones are available
    //   setSelectedCalendarZoneId(0);
    //   setSelectedZoneName('No Zones Available');
    //   localStorage.removeItem(SESSION.selectedZoneIDInCalendarScreen);
    // }
    //             // // Process zoneData for dropdown
    //             // const fetchedZoneList = zoneData?.Data?.Records?.ZoneList ?? [];
    //             // setZoneList(fetchedZoneList); // Update the list of zones for the dropdown
    //             // console.log("Fetched Zone List for dropdown (from ZoneList_api):", fetchedZoneList);

    //             // let initialZoneId = 0;
    //             // let initialZoneName = '-- Select a Zone --';
    //             // let zoneToSelect = null;

    //             // const storedZoneIdString = localStorage.getItem(SESSION.selectedZoneIDInCalendarScreen);
    //             // const storedZoneId = storedZoneIdString ? parseInt(storedZoneIdString, 10) : null;

    //             // if (storedZoneId !== null) {
    //             //     const foundZone = fetchedZoneList.find((zone) => zone.Id === storedZoneId);
    //             //     if (foundZone) {
    //             //         zoneToSelect = foundZone;
    //             //     }
    //             // }

    //             // if (!zoneToSelect && fetchedZoneList.length > 0) {
    //             //     const zoneToSelect = fetchedZoneList.find(zone => zone.DefaultId === 1) || zoneList[0];
    //             //     // if (defaultZone) {
    //             //     //     zoneToSelect = defaultZone;
    //             //     // } else {
    //             //     //     zoneToSelect = fetchedZoneList[0];
    //             //     // }
    //             // }

    //             // if (zoneToSelect) {
    //             //     // initialZoneId = zoneToSelect.Id;
    //             //     // initialZoneName = zoneToSelect.ZoneName;
    //             //     // localStorage.setItem(SESSION.selectedZoneIDInCalendarScreen, initialZoneId.toString());
    //             //     setSelectedCalendarZoneId(zoneToSelect.Id);
    //             //     setSelectedZoneName(zoneToSelect.ZoneName);
    //             // } else if (fetchedZoneList.length === 0) {
    //             //     initialZoneId = 0;
    //             //     initialZoneName = 'No Zones Available';
    //             //     localStorage.removeItem(SESSION.selectedZoneIDInCalendarScreen);
    //             // } else {
    //             //     initialZoneId = 0;
    //             //     initialZoneName = '-- Select a Zone --';
    //             // }

    //             // Handle calendarData for initial display
    //             if (calendarData?.Data?.ResponseCode === 200) {
    //                 setRecordsData(calendarData?.Data?.Records);
    //                 setUserFirstName(calendarData?.Data?.Records?.FirstName ?? "");
    //                 setMainCurrentDate(calendarData?.Data?.Records?.ZoneCurrentDate ?? "");
    //                 setTeamLeadFlag(calendarData?.Data?.Records?.TeamLeadFlag ?? 0);
    //                 setIsQueue(calendarData?.Data?.Records?.QueueUser ?? 0);
    //                 setPreBookingQuestion(calendarData?.Data?.Records?.PreBookingQuestion ?? "");
    //                 setMapAvailable(calendarData?.Data?.Records?.MapExist);
    //                 setMapAvailableType(calendarData?.Data?.Records?.MapType);

    //                 console.log("Map availability from initial Calendar_API call:", calendarData?.Data?.Records?.MapType);

    //                 const zoneCreditValueString = calendarData?.Data?.Records?.ZoneCreditValue;
    //                 const userCreditBalanceFromAPI = calendarData?.Data?.Records?.CreditBalance;

    //                 setUserZoneCreditValue(zoneCreditValueString);
    //                 setUserZoneCreditBalance(userCreditBalanceFromAPI);

    //                 if (Array.isArray(calendarData.Data.Records.Schedule)) {
    //                     setBookingSpotData(calendarData.Data.Records.Schedule);
    //                     console.log(bookingSpotData, "Schedule data from initial Calendar_API call");
    //                 } else if (calendarData.Data.Records.Schedule?.SpotId === 0) {
    //                     setBookingSpotData([]);
    //                 } else {
    //                     console.warn("Unexpected schedule data format:", calendarData.Data.Records.Schedule);
    //                     setBookingSpotData([]);
    //                 }
    //             } else {
    //                 console.error("Initial Calendar_API response code not 200:", calendarData?.Data?.ResponseCode);
    //                 setBookingSpotData([]); // Clear calendar data on initial load if API fails
    //             }

    //         } catch (err) {
    //             console.error("Error fetching initial data in Calendar_Logic:", err);
    //             setBookingSpotData([]);
    //             setZoneList([]);
    //             setSelectedCalendarZoneId(0);
    //             setSelectedZoneName('Error loading zones');
    //             setCreditInfoJSX(null);
    //             localStorage.removeItem(SESSION.selectedZoneIDInCalendarScreen);
    //         } finally {
    //             setIsLoading(false);
    //         }
    //     }, [Login, FetchCalendarWithZone, setZoneList, setSelectedCalendarZoneId, setSelectedZoneName, setRecordsData, setMainCurrentDate, setTeamLeadFlag, setIsQueue, setPreBookingQuestion, setCreditInfoJSX, setBookingSpotData, performCalendarApiCall, SESSION.selectedZoneIDInCalendarScreen]);

    const handleZoneChange = useCallback(async (event) => {
        const newZoneId = parseInt(event.target.value, 10);
        const newZoneName = event.target.options[event.target.selectedIndex].text;

        if (isNaN(newZoneId)) {
            console.warn("Invalid zone ID selected:", event.target.value);
            return;
        }
        setSelectedCalendarZoneId(newZoneId);
        setSelectedZoneName(newZoneName);
        // localStorage.setItem(SESSION.selectedZoneIDInCalendarScreen, newZoneId.toString());
        sessionStorage.setItem(SESSION.selectedZoneIDInCalendarScreen, newZoneId.toString());

        setWeekData({});
        setLoadingWeeks({});

        setIsLoading(true);
        try {
            // Only call the Calendar API here
            const { calendarData, error } = await FetchCalendarWithZone(newZoneId);
            if (!error && calendarData?.Data?.ResponseCode === 200) {
                setMapAvailable(calendarData?.Data?.Records?.MapExist);
                setMapAvailableType(calendarData?.Data?.Records?.MapType);
                setRecordsData(calendarData?.Data?.Records);
                setMainCurrentDate(calendarData?.Data?.Records?.ZoneCurrentDate ?? "");
                setTeamLeadFlag(calendarData?.Data?.Records?.TeamLeadFlag ?? 0);
                setIsQueue(calendarData?.Data?.Records?.QueueUser ?? 0);
                setPreBookingQuestion(calendarData?.Data?.Records?.PreBookingQuestion ?? "");
                setCreditInfoJSX(calendarData?.Data?.Records?.CreditInfoJSX ?? null);

                if (Array.isArray(calendarData.Data.Records.Schedule)) {
                    setBookingSpotData(calendarData.Data.Records.Schedule);
                } else {
                    setBookingSpotData([]);
                }
            } else {
                setMapAvailable(0);
                setMapAvailableType(0);
                setBookingSpotData([]);
            }
        } catch (err) {
            console.error("Error fetching calendar data for zone change:", err);
            setMapAvailable(0);
            setMapAvailableType(0);
            setBookingSpotData([]);
        } finally {
            setIsLoading(false);
        }

        // Only refetch events if needed (no extra API call)
        if (calendarRef && calendarRef.current) {
            calendarRef.current.getApi().refetchEvents();
        }
    }, [
        setSelectedCalendarZoneId,
        setSelectedZoneName,
        setWeekData,
        setLoadingWeeks,
        setIsLoading,
        setMapAvailable,
        setMapAvailableType,
        setRecordsData,
        setMainCurrentDate,
        setTeamLeadFlag,
        setIsQueue,
        setPreBookingQuestion,
        setCreditInfoJSX,
        setBookingSpotData,
        calendarRef,
        SESSION.selectedZoneIDInCalendarScreen,
        FetchCalendarWithZone
    ]);

    const handleCancelBookingClick = (date) => {
        setBookingToCancelDate(date);
        setShowCancelModal(true);
    };

    const handleShowBookingModal = (date) => {
        setBookingCreateDate(date);
        setShowBookingModal(true);
    };

    // Define your button click handlers here
    // const handleMeetingButtonClick = (date) => {
    //     setSelectedMeetingDate(date);
    //     setShowMeetingModal(true);
    // };

    const ScheduleMeeting = (zoneId, bookingDateStr) => {
        console.log("Schedule Meeting Clicked", zoneId, bookingDateStr);
        setShowMeetingModal(false); // Close the current popup
        setShowScheduleMeetingModal(true); // Open the new popup
    };

    const handleJoinQueueModal = (date) => {
        setJoinQueueDate(date);
        setShowJoinQueueModal(true);
    }

    const handleLeaveQueueModal = (date) => {
        setLeaveQueueDate(date);
        setShowLeaveQueueModal(true);
    }

    const renderDayCellContent = (dayCellInfo) => {
        const currentDate = dayCellInfo.date;
        const cellDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
        const currentDateString = currentDate.toISOString().slice(0, 10);

        const isSelected = currentDateString === selectedDate;

        const today = new Date();
        const todayMidnight = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        const cellDateMidnight = new Date(cellDate.getFullYear(), cellDate.getMonth(), cellDate.getDate());

        const isPastDate = cellDateMidnight < todayMidnight;

        const cellWrapperStyle = isPastDate ? {
            backgroundColor: 'transparent', // Or whatever default FullCalendar background is
            pointerEvents: 'none', // Disable clicks on the entire cell
            opacity: 1, // Ensure the cell itself isn't faded
            // You might need to adjust height/width if your custom content was dictating it
            // height: '100%',
            // width: '100%',
        } : {};

        const firstDayOfWeek = new Date(currentDate);
        const dayOfWeek = firstDayOfWeek.getDay();
        const diff = firstDayOfWeek.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
        const mondayOfWeek = new Date(firstDayOfWeek.setDate(diff));
        const weekKey = `${mondayOfWeek.getFullYear()}-${mondayOfWeek.getMonth()}-${mondayOfWeek.getDate()}`;

        const weekBookings = weekData[weekKey] || bookingSpotData;
        const hasFetchedData = weekData.hasOwnProperty(weekKey);

        const bookingOnDate = weekBookings.find((booking) => {
            return booking.BookingDate === currentDateString; // Direct string comparison

        });

        const dateNumber = currentDate.getDate();

        return (
            <CalendarLogic
                dayCellInfo={dayCellInfo}
                selectedDate={selectedDate}
                availabilityDays={availabilityDays}
                weekData={weekData}
                bookingSpotData={bookingSpotData}
                formatDateString={formatDateString}

                loadingWeeks={loadingWeeks}
                setLoadingWeeks={setLoadingWeeks}
                ZoneList={ZoneList}
                fetchWithTokenRefresh2={fetchWithTokenRefresh2}
                BASE_URL={BASE_URL}
                Calendar_api={Calendar_api}
                getGuId={getGuId}
                setWeekData={setWeekData}
                setCalendarRenderKey={setCalendarRenderKey}
                zoneList={zoneList}
                selectedZoneName={selectedZoneName}
                selectedCalendarZoneId={selectedCalendarZoneId}
                // onZoneChange={handleZoneChange} // Renamed for clarity: `on` prefix for callbacks
                mainCurrentDate={mainCurrentDate} // Initial current date from global load
                teamLeadFlag={teamLeadFlag}
                isQueue={isQueue}
                preBookingQuestion={preBookingQuestion}
                recordsData={recordsData}
                isPastDate={isPastDate}
                performCalendarApiCall={performCalendarApiCall}// Pass the selected zone ID
                creditInfoJSX={creditInfoJSX}
                bookingOnDate={bookingOnDate}
                handleCancelBookingClick={handleCancelBookingClick}
                handleShowBookingModal={handleShowBookingModal}
                handleJoinQueueModal={handleJoinQueueModal}
                handleLeaveQueueModal={handleLeaveQueueModal}
                // selectedZoneId={selectedCalendarZoneId}
                mapAvailable={mapAvailable}
                mapAvailableType={mapAvailableType}
                setMapAvailable={setMapAvailable}
                setMapAvailableType={setMapAvailableType}
                setBookingSpotData={setBookingSpotData}

                loadingDates={loadingDates}
                currentDateString={currentDateString}
            />
        );
    };

    // Rest of your utility functions and modal components...
    const formattedDate = currentDate.toLocaleDateString('en-US', {
        day: 'numeric',
        month: 'short',
    });

    const formattedOnlyDate = currentDate.toLocaleDateString('en-US', {
        day: 'numeric',
    });

    const formattedOnlyMonth = currentDate.toLocaleDateString('en-US', {
        month: 'long',
    });
    const formattedOnlyMonthShort = currentDate.toLocaleDateString('en-US', {
        month: 'short',
    });

    const formattedOnlyYear = currentDate.toLocaleDateString('en-US', {
        year: 'numeric'
    });

    const handleEventClick = (clickInfo) => {
        const updatedEvents = events.map((event) => {
            if (event.id === clickInfo.event.id) {
                return {
                    ...event,
                    status: event.status === 'available' ? 'checked-in' : 'available',
                };
            }
            return event;
        });
        setEvents(updatedEvents);
    };

    const handleCheckInButtonClick = () => {
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
    };

    const handleViewMount = (info) => {
        setIsLoading(true);
        if (info.view.type === 'timeGridWeek') {
            formatTimeGridWeekHeaders(info.el);
            renderCustomAllDayHTML(info.el);
            renderCustomNavigationButtons(info.el);
            addPercentageData(info.el);
            setIsLoading(false);
        } else {
            setIsLoading(false);
        }
    };

    function generateUniquePercentages(count, min, max) {
        var percentages = new Set();
        while (percentages.size < count) {
            var percentage = Math.floor(Math.random() * (max - min + 1)) + min;
            percentages.add(percentage);
        }
        return Array.from(percentages);
    }

    function formatTimeGridWeekHeaders() {
        var headerEls = document.querySelectorAll(".fc-col-header th");
        headerEls.forEach(function (headerEl) {
            var date = new Date(headerEl.getAttribute("data-date"));
            var dayName = new Intl.DateTimeFormat("en-US", { weekday: "short" }).format(date);
            var dayDate = ("0" + date.getDate()).slice(-2); // Add leading zero
            headerEl.innerHTML = `<div class="name-date-header text-center"><div class="day-name">${dayName}</div><div class="day-date">${dayDate}</div></div>`;
        });
    }

    function renderCustomAllDayHTML() {
        var allDayRow = document.querySelector(".fc-col-header .fc-daygrid-header-row");
        if (allDayRow) {
            var firstCol = allDayRow.querySelector("th:first-child");
            if (firstCol) {
                firstCol.innerHTML = `<div class="custom-all-day">Custom All-Day HTML</div>`;
            }
        }
    }

    function renderCustomNavigationButtons() {
        var timeGridView = document.querySelector(".fc-timeGridWeek-view");
        if (timeGridView) {
            var existingButtons = document.querySelector(".custom-navigation-buttons");
            if (!existingButtons) {
                var buttonContainer = document.createElement("div");
                buttonContainer.className = "custom-navigation-buttons";

                var prevButton = document.createElement("button");
                prevButton.className = "custom-prev-week-button fc-button fc-prev-button";
                prevButton.innerHTML = "<span></span>";
                prevButton.addEventListener("click", function () {
                    // calendar.prev(); // Go to previous week
                });

                var nextButton = document.createElement("button");
                nextButton.className = "custom-next-week-button fc-button fc-next-button";
                nextButton.innerHTML = "<span></span>";
                nextButton.addEventListener("click", function () {
                    // calendar.next(); // Go to next week
                });

                buttonContainer.appendChild(prevButton);
                buttonContainer.appendChild(nextButton);

                timeGridView.insertBefore(buttonContainer, timeGridView.firstChild);
            }
        } else {
            console.error(".fc-timeGridWeek-view not found.");
        }
    }

    function areAllDaysInPast(view) {
        var currentDate = view.currentStart;
        var today = new Date();
        today.setHours(0, 0, 0, 0); // Midnight for accurate comparison

        var allDaysInPast = true;
        for (var i = 0; i < 7; i++) {
            var dateToCheck = new Date(currentDate);
            dateToCheck.setDate(dateToCheck.getDate() + i);
            if (dateToCheck >= today) {
                allDaysInPast = false;
                break;
            }
        }
        return allDaysInPast;
    }

    // This function is defined twice in your original code. Keeping one.
    // function generateUniquePercentages(count, min, max) { ... }

    function addPercentageData() {
        var sectionBody = document.querySelector(".fc-scrollgrid-section-body");
        if (sectionBody) {
            var cells = sectionBody.querySelectorAll(".fc-daygrid-day"); // Adjust selector if needed
            cells.forEach(function (cell, index) {
                if (index < weeklyPercentages.length) {
                    var percentage = weeklyPercentages[index];
                    if (!cell.classList.contains("percentage-added")) {
                        var percentageClass = percentage === 100 ? "percentage-100" : "percentage-data";
                        // This seems to overwrite the entire cell content, including date number.
                        // You might need to append this data to an existing div or create a new one.
                        // For now, I'll comment out this part as it might conflict with CalendarLogicDesign.
                        // cell.innerHTML = `<div class="${percentageClass}">${percentage}%</div>`;
                        cell.classList.add("percentage-added");
                    }
                }
            });
        }
    }

    const handleDatesSet = (info) => {
        // This function is called when the calendar's dates are initially set or changed (e.g., prev/next month)
        // Here, we can trigger a fetch for the newly visible week/month if needed.

        // Determine the start date of the visible range
        const viewStart = info.view.currentStart;
        const currentMonday = new Date(viewStart.getFullYear(), viewStart.getMonth(), viewStart.getDate());
        currentMonday.setDate(currentMonday.getDate() - currentMonday.getDay() + (currentMonday.getDay() === 0 ? -6 : 1));
        currentMonday.setHours(0, 0, 0, 0);
        const weekKey = `${currentMonday.getFullYear()}-${currentMonday.getMonth()}-${currentMonday.getDate()}`;

        // Only fetch if data for this week is not already loaded AND a zone is selected
        if (!weekData.hasOwnProperty(weekKey) && selectedCalendarZoneId !== 0) {
            performCalendarApiCall(currentMonday, selectedCalendarZoneId);
        }


        // Your existing logic for timeGridWeek view
        if (info.view.type === 'timeGridWeek') {
            formatTimeGridWeekHeaders(info.el);
            renderCustomAllDayHTML(info.el);
            renderCustomNavigationButtons(info.el);
            addPercentageData(info.el);

            const prevButton = info.el.querySelector('.custom-prev-week-button');
            if (prevButton) {
                prevButton.disabled = areAllDaysInPast(info.view.currentStart);
                prevButton.classList.toggle('fc-button-disabled', prevButton.disabled);
            }
        } else {
            const prevButton = document.querySelector('.custom-prev-week-button');
            if (prevButton) {
                prevButton.disabled = false;
                prevButton.classList.remove('fc-button-disabled');
            }
        }
    };

    const handleDateClick = (info) => {
        setSelectedDate(info.dateStr);

        const clickedDate = info.date;
        const clickedDay = clickedDate.getDate();
        const clickedMonth = clickedDate.getMonth() + 1;
        const clickedYear = clickedDate.getFullYear();

        const fullday = `${clickedYear}-${clickedMonth}-${clickedDay}`;

        setSelectedDay(clickedDay);
        setSelectedMonth(clickedMonth);
        setSelectedYear(clickedYear);

        setClickedFullDay(fullday);

        console.log("📅 Clicked Date:", fullday);

        // 🔍 Find matching bookings from bookingSpotData
        const matchedSchedules = bookingSpotData.filter((booking) => {
            const bookingDate = formatDateString(booking.BookingDate);

            if (!(bookingDate instanceof Date) || isNaN(bookingDate.getTime())) {
                return false;
            }

            return (
                bookingDate.getFullYear() === clickedYear &&
                bookingDate.getMonth() + 1 === clickedMonth &&
                bookingDate.getDate() === clickedDay
            );
        });

        console.log("📦 Matching Schedule Records:", matchedSchedules);

        if (matchedSchedules.length > 0) {
            setCancelBookingSpotId(matchedSchedules[0].SpotId);
            console.log("Selected SpotId:", matchedSchedules[0].SpotId);
        } else {
            setCancelBookingSpotId(null);
            console.log("No SpotId found for this date.");
        }
    };

    // The formatDateString function is now a useCallback at the top.
    // const formatDateString = (dateString) => {
    //     const [year, month, day] = dateString.split('-');
    //     return new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10));
    // };

    const handleBookButtonClick = (dateStr) => {
        alert(`Book button clicked for: ${dateStr}`);
    };

    // BookingModal and CancellationModal components (keep them as they are, but ensure they receive correct props)
    const BookingModal = ({ date, onClose, zoneId, onBookingSuccess }) => {

        // Helper to get weekKey for a given date
        function getWeekKey() {
            const date = clickedFullDay
            console.log("click on date clickedFullDay => ", date);
            const d = new Date(date);
            const dayOfWeek = d.getDay();
            console.log("Number of day in week => ", dayOfWeek);
            const diff = d.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
            const monday = new Date(d.setDate(diff));
            return `${monday.getFullYear()}-${monday.getMonth()}-${monday.getDate()}`;
        }

        const bookingDate = clickedFullDay;
        const weekKey = bookingDate ? getWeekKey(bookingDate) : null;

        const d = new Date(bookingDate);
        const bookingDateStr = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

        console.log("Booking Date String:", bookingDateStr);
        console.log("Booking Date:", bookingDate);
        console.log("Week Key:", weekKey);
        console.log("Booking Date String:", bookingDateStr);

        // Find booking for modal from weekData first, fallback to bookingSpotData
        const bookingForModal =
            (weekKey && weekData && weekData[weekKey] && weekData[weekKey].find(
                (booking) => booking.BookingDate === bookingDateStr
            )) ||
            bookingSpotData.find(
                (booking) => booking.BookingDate === bookingDateStr
            );

        // Display helpers
        console.log("Booking for modal:", bookingForModal);
        const displayDay = bookingDate ? new Date(bookingDate).getDate() : '';
        const displayMonth = bookingDate ? new Date(bookingDate).toLocaleDateString('en-US', { month: 'long' }) : '';
        const displayYear = bookingDate ? new Date(bookingDate).getFullYear() : '';

        return (
            <div>
                <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
                    id="dateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered modal-custom-width">
                        <div className="modal-content modal-radius">
                            <div className="modal-body">
                                <div className="close-modal">
                                    <a onClick={onClose}>
                                        <img src={Close} aria-label="Close" />
                                    </a>
                                </div>
                                <div className="pt-4">
                                    <h5 className="popup-title">New Booking..</h5>
                                </div>
                                <div className="date-with-credit d-flex align-items-center justify-content-between pt-2">
                                    <div id="selectedDate" className="selected-current-date">
                                        <span>{selectedDay}</span>
                                        <span>{displayMonth} &nbsp; {displayYear}</span>
                                    </div>
                                    <div className="credit-info">
                                        {creditInfoJSX}
                                    </div>
                                </div>
                                <div className="divider-line mt-3"></div>
                                <div className="text-center my-34">
                                    <img src={Deskbooking} className="img-fluid" alt="Desk Booking" />
                                </div>

                                {/* This is inside your modal's JSX, where you are rendering the booking options */}
                                {(() => {
                                    if (!bookingForModal) return null;

                                    // Case: Map is available and not of type 1 (meaning it offers both Desk and Meeting Room or other types)
                                    if (mapAvailable === 1 && mapAvailableType !== 1) {
                                        // Sub-case: Both Desk and Meeting Room are available
                                        if (bookingForModal.DeskAvailable === 1 && bookingForModal.MeetingRoomAvailable === 1) {
                                            return (
                                                <>
                                                    <div className="mb-4">
                                                        <a
                                                            onClick={() => GotoMapClick(zoneId, bookingDateStr)}
                                                            href="#"
                                                            className="green-outline-with-icon w-100 mw-100 min-height-56 selected"
                                                        >
                                                            <img src={GreenMap} alt="Map" />
                                                            <span>Go to Map</span>
                                                        </a>
                                                    </div>
                                                    <div className="mb-4">
                                                        {/* Get Random Space Button */}
                                                        <a
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                if (!isLoading) {
                                                                    GetRandomSpace(zoneId, bookingDateStr);
                                                                    onClose(); 
                                                                }
                                                            }}
                                                            href="#"
                                                            className={`green-outline-with-icon w-100 mw-100 min-height-56 ${isLoading ? 'disabled' : ''}`}
                                                            // Optional: Visually disable pointer events when loading
                                                            style={{ pointerEvents: isLoading ? 'none' : 'auto' }}
                                                        >
                                                            {isLoading ? (
                                                                <>
                                                                    <div className="animate-spin h-5 w-5 mr-3 border-t-2 border-b-2 border-green-500 rounded-full"></div>
                                                                    <span>Loading...</span>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <img src={EditSquare} alt="Edit" />
                                                                    <span>Get Random Space</span>
                                                                </>
                                                            )}
                                                        </a>
                                                    </div>
                                                    <div className="">
                                                        <a onClick={(e) => {
                                                            e.preventDefault();
                                                            if (!isLoading) {
                                                                ScheduleMeeting(zoneId, bookingDateStr);
                                                                onClose();
                                                            }
                                                        }}
                                                            href="#" className="green-outline-with-icon w-100 mw-100 min-height-56">
                                                            <img src={ScheduleMeetingicon} alt="Edit" />
                                                            <span>Schedule Meeting</span>
                                                        </a>
                                                    </div>
                                                </>
                                            );
                                        }
                                        // Sub-case: Only Desk available
                                        if (bookingForModal.DeskAvailable === 1) {
                                            return (
                                                <>
                                                    <div className="mb-4">
                                                        <a
                                                            onClick={() => GotoMapClick(zoneId, bookingDateStr)}
                                                            href="#"
                                                            className="green-outline-with-icon w-100 mw-100 min-height-56 selected"
                                                        >
                                                            <img src={GreenMap} alt="Map" />
                                                            <span>Go to Map</span>
                                                        </a>
                                                    </div>
                                                    <div className="mb-4">
                                                        <a
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                if (!isLoading) {
                                                                    GetRandomSpace(zoneId, bookingDateStr);
                                                                    onClose();
                                                                }
                                                            }}
                                                            href="#"
                                                            className={`green-outline-with-icon w-100 mw-100 min-height-56 ${isLoading ? 'disabled' : ''}`}
                                                            style={{ pointerEvents: isLoading ? 'none' : 'auto' }}
                                                        >
                                                            {isLoading ? (
                                                                <>
                                                                    <div className="animate-spin h-5 w-5 mr-3 border-t-2 border-b-2 border-green-500 rounded-full"></div>
                                                                    <span>Loading...</span>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <img src={EditSquare} alt="Edit" />
                                                                    <span>Get Random Space</span>
                                                                </>
                                                            )}
                                                        </a>
                                                    </div>
                                                </>
                                            );
                                        }
                                        // Sub-case: Only Meeting Room available
                                        if (bookingForModal.MeetingRoomAvailable === 1) {
                                            return (
                                                <>
                                                    <div className="mb-4">
                                                        <a
                                                            onClick={() => GotoMapClick(zoneId, bookingDateStr)}
                                                            href="#"
                                                            className="green-outline-with-icon w-100 mw-100 min-height-56 selected"
                                                        >
                                                            <img src={GreenMap} alt="Map" />
                                                            <span>Go to Map</span>
                                                        </a>
                                                    </div>
                                                    <div className="">
                                                        <a
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                if (!isLoading) {
                                                                    ScheduleMeeting(zoneId, bookingDateStr);
                                                                    onClose();
                                                                }
                                                            }}
                                                            href="#" className="green-outline-with-icon w-100 mw-100 min-height-56">
                                                            <img src={ScheduleMeetingicon} alt="Edit" />
                                                            <span>Schedule Meeting</span>
                                                        </a>
                                                    </div>
                                                </>
                                            );
                                        }
                                        // Sub-case: DeskCount === 1 and DeskAvailable === 0 (if only hourly booking is available)
                                        if (bookingForModal.DeskCount === 1 && bookingForModal.DeskAvailable === 0) {
                                            return (
                                                <div className="mb-4">
                                                    <a
                                                        onClick={() => GotoMapClick(zoneId, bookingDateStr)}
                                                        href="#"
                                                        className="green-outline-with-icon w-100 mw-100 min-height-56 selected"
                                                    >
                                                        <img src={GreenMap} alt="Map" />
                                                        <span>Go to Map</span>
                                                    </a>
                                                </div>
                                            );
                                        }
                                        // Fallback: just show map if available
                                        return (
                                            <div className="mb-4">
                                                <a
                                                    onClick={() => GotoMapClick(zoneId, bookingDateStr)}
                                                    href="#"
                                                    className="green-outline-with-icon w-100 mw-100 min-height-56 selected"
                                                >
                                                    <img src={GreenMap} alt="Map" />
                                                    <span>Go to Map</span>
                                                </a>
                                            </div>
                                        );
                                    }

                                    // Case: If mapAvailable === 0, show only Get Random Space
                                    if (mapAvailable === 0) {
                                        return (
                                            <div className="">
                                                <a
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        if (!isLoading) {
                                                            GetRandomSpace(zoneId, bookingDateStr);
                                                            onClose();
                                                        }
                                                    }}
                                                    href="#"
                                                    className={`green-outline-with-icon w-100 mw-100 min-height-56 ${isLoading ? 'disabled' : ''}`}
                                                    style={{ pointerEvents: isLoading ? 'none' : 'auto' }}
                                                >
                                                    {isLoading ? (
                                                        <>
                                                            <div className="animate-spin h-5 w-5 mr-3 border-t-2 border-b-2 border-green-500 rounded-full"></div>
                                                            <span>Loading...</span>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <img src={EditSquare} alt="Edit" />
                                                            <span>Get Random Space</span>
                                                        </>
                                                    )}
                                                </a>
                                            </div>
                                        );
                                    }
                                    return null;
                                })()
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const CancellationModal = ({ date, onClose, zoneId, cancelBookingSpotId }) => {
        // Helper to get weekKey for a given date
        function getWeekKey() {
            const date = clickedFullDay
            // console.log("click on date clickedFullDay => ", date);
            const d = new Date(date);
            const dayOfWeek = d.getDay();
            // console.log("Number of day in week => ", dayOfWeek);
            const diff = d.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
            const monday = new Date(d.setDate(diff));
            return `${monday.getFullYear()}-${monday.getMonth()}-${monday.getDate()}`;
        }

        const bookingDate = clickedFullDay;
        const weekKey = bookingDate ? getWeekKey(bookingDate) : null;

        const d = new Date(bookingDate);
        const bookingDateStr = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

        // console.log("Booking Date String:", bookingDateStr);

        // console.log("Booking Date:", bookingDate);
        // console.log("Week Key:", weekKey);
        // console.log("Booking Date String:", bookingDateStr);

        // Find booking for modal from weekData first, fallback to bookingSpotData
        const bookingForModal =
            (weekKey && weekData && weekData[weekKey] && weekData[weekKey].find(
                (booking) => booking.BookingDate === bookingDateStr
            )) ||
            bookingSpotData.find(
                (booking) => booking.BookingDate === bookingDateStr
            );

        // Display helpers
        const displayDay = bookingDate ? new Date(bookingDate).getDate() : '';
        const displayMonth = bookingDate ? new Date(bookingDate).toLocaleDateString('en-US', { month: 'long' }) : '';
        const displayYear = bookingDate ? new Date(bookingDate).getFullYear() : '';
        return (
            <div>
                <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
                    id="dateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered modal-custom-width">
                        <div className="modal-content modal-radius">
                            <div className="modal-body">
                                <div className="close-modal">
                                    <a onClick={onClose}>
                                        <img src={Close} aria-label="Close" />
                                    </a>
                                </div>
                                <div className="pt-4">
                                    <h5 className="popup-title">Cancel Booking.</h5>
                                </div>
                                <div className="date-with-credit d-flex align-items-center justify-content-between pt-2">
                                    <div id="selectedDate" className="selected-current-date">
                                        <span>{selectedDay}</span>
                                        <span>{displayMonth} &nbsp; {displayYear}</span>
                                    </div>
                                    <div className="credit-info">
                                        {creditInfoJSX}
                                    </div>
                                </div>
                                <div className="divider-line mt-3"></div>
                                <div className="text-center my-34">
                                    <img src={Deskbooking} className="img-fluid" alt="Desk Booking" />
                                </div>

                                {
                                    (() => {
                                        if (!bookingForModal) return null;
                                        if (mapAvailable === 1 && mapAvailableType !== 1) {
                                            // Both Desk and Meeting Room available
                                            if (bookingForModal.DeskAvailable === 0 && bookingForModal.DeskCount === 1 || bookingForModal.MeetingRoomAvailable === 1) {
                                                return (
                                                    <>
                                                        <div className="mb-4">
                                                            <a
                                                                onClick={() => GotoMapClick(zoneId, bookingDateStr)}
                                                                href="#" className="green-outline-with-icon w-100 mw-100 min-height-56 selected">
                                                                <img src={GreenMap} alt="Map" /><span>Go to Map</span>
                                                            </a>
                                                        </div>
                                                        <div className="mb-4">
                                                            <a

                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    if (!isLoading) {
                                                                        ScheduleMeeting(zoneId, bookingDateStr); // This is the core action
                                                                        onClose(); // This closes the current view/modal
                                                                    }
                                                                }}
                                                                href="#" className="green-outline-with-icon w-100 mw-100 min-height-56">
                                                                <img src={ScheduleMeetingicon} alt="Edit" /><span>Schedule Meeting</span>
                                                            </a>
                                                        </div>
                                                        {bookingForModal.MeetingCount === 0 && (
                                                        <div className="">
                                                            <a
                                                                onClick={() => {
                                                                    // console.log("Passing spotId to CancelBooking:", cancelBookingSpotId);
                                                                    CancelBooking(zoneId, bookingDateStr, cancelBookingSpotId);
                                                                    onClose();
                                                                }}
                                                                href="#" className="main-btn outline-gray-btn w-100 mw-100 min-height-56">
                                                                {/* <img src={EditSquare} alt="Edit" /> */}
                                                                <span>Cancel Booking</span>
                                                            </a>
                                                        </div>
                                                        )}
                                                    </>
                                                );
                                            }
                                            // Only Desk available
                                            if (bookingForModal.DeskAvailable === 0 && bookingForModal.DeskCount === 1) {
                                                return (
                                                    <>
                                                        <div className="">
                                                            <a
                                                                onClick={() => {
                                                                    // console.log("Passing spotId to CancelBooking:", cancelBookingSpotId);
                                                                    CancelBooking(zoneId, bookingDateStr, cancelBookingSpotId);
                                                                    onClose();
                                                                }}
                                                                href="#" className="main-btn outline-gray-btn w-100 mw-100 min-height-56">
                                                                {/* <img src={EditSquare} alt="Edit" /> */}
                                                                <span>Cancel Booking</span>
                                                            </a>
                                                        </div>
                                                    </>
                                                );
                                            }
                                            // Only Meeting Room available
                                            if (bookingForModal.MeetingRoomAvailable === 0 && bookingForModal.MeetingCount === 1) {
                                                return (
                                                    <>
                                                        <div className="mb-4">
                                                            <a
                                                                onClick={() => GotoMapClick(zoneId, bookingDateStr)}
                                                                href="#" className="green-outline-with-icon w-100 mw-100 min-height-56 selected">
                                                                <img src={GreenMap} alt="Map" /><span>Go to Map</span>
                                                            </a>
                                                        </div>
                                                        <div className="">
                                                            <a href="#" className="main-btn outline-gray-btn w-100 mw-100 min-height-56">
                                                                {/* <img src={EditSquare} alt="Edit" /> */}
                                                                <span>Cancel Meeting</span>
                                                            </a>
                                                        </div>
                                                    </>
                                                );
                                            }
                                        }
                                        // If mapAvailable === 0, show only Cancel Booking
                                        if (mapAvailable === 0) {
                                            // if (bookingForModal.DeskCount == 1) {
                                            return (
                                                <div className="">
                                                    <a
                                                        onClick={() => {
                                                            // console.log("Passing spotId to CancelBooking:", cancelBookingSpotId);
                                                            CancelBooking(zoneId, bookingDateStr, cancelBookingSpotId);
                                                            onClose();
                                                        }}
                                                        href="#" className="main-btn outline-gray-btn w-100 mw-100 min-height-56">
                                                        {/* <img src={EditSquare} alt="Edit" /> */}
                                                        <span>Cancel Booking</span>
                                                    </a>
                                                </div>
                                            );
                                            // }
                                        }
                                        return null;
                                    })()
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const JoinQueueModal = ({ date, onClose, zoneId }) => {
        // Helper to get weekKey for a given date
        function getWeekKey() {
            const date = clickedFullDay
            console.log("click on date clickedFullDay => ", date);
            const d = new Date(date);
            const dayOfWeek = d.getDay();
            console.log("Number of day in week => ", dayOfWeek);
            const diff = d.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
            const monday = new Date(d.setDate(diff));
            return `${monday.getFullYear()}-${monday.getMonth()}-${monday.getDate()}`;
        }

        const bookingDate = clickedFullDay;
        const weekKey = bookingDate ? getWeekKey(bookingDate) : null;

        const d = new Date(bookingDate);
        const bookingDateStr = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

        // Find booking for modal from weekData first, fallback to bookingSpotData
        const bookingForModal =
            (weekKey && weekData && weekData[weekKey] && weekData[weekKey].find(
                (booking) => booking.BookingDate === bookingDateStr
            )) ||
            bookingSpotData.find(
                (booking) => booking.BookingDate === bookingDateStr
            );

        // Display helpers
        const displayDay = bookingDate ? new Date(bookingDate).getDate() : '';
        const displayMonth = bookingDate ? new Date(bookingDate).toLocaleDateString('en-US', { month: 'long' }) : '';
        const displayYear = bookingDate ? new Date(bookingDate).getFullYear() : '';
        return (
            <div>
                <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
                    id="dateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered modal-custom-width">
                        <div className="modal-content modal-radius">
                            <div className="modal-body">
                                <div className="close-modal">
                                    <a onClick={onClose}>
                                        <img src={Close} aria-label="Close" />
                                    </a>
                                </div>
                                <div className="pt-4">
                                    <h5 className="popup-title">No Space left on </h5>
                                </div>
                                <div className="date-with-credit d-flex align-items-center justify-content-between pt-2">
                                    <div id="selectedDate" className="selected-current-date">
                                        <span>{selectedDay}</span>
                                        <span>{displayMonth} &nbsp; {displayYear}</span>
                                    </div>
                                    <div className="credit-info">
                                        {creditInfoJSX}
                                    </div>
                                </div>
                                <div className="divider-line mt-3"></div>
                                <div className="text-center my-34">
                                    <img src={Deskbooking} className="img-fluid" alt="Desk Booking" />
                                </div>

                                {
                                    (() => {
                                        if (!bookingForModal) return null;
                                        if (isQueue === 1) {
                                            // Both Desk and Meeting Room available
                                            if (bookingForModal.DisplayQueue === 1) {
                                                return (
                                                    <>
                                                        <div className="mb-4">
                                                            <a
                                                                onClick={() => JoinQueueModal(zoneId, bookingDateStr)}
                                                                href="#" className="green-outline-with-icon w-100 mw-100 min-height-56 selected">
                                                                <img src={GreenMap} alt="Map" /><span>Join to the queue</span>
                                                            </a>
                                                        </div>
                                                    </>
                                                );
                                            }
                                        }
                                        return null;
                                    })()
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const LeaveQueueModal = ({ date, onClose, zoneId }) => {
        // Helper to get weekKey for a given date
        function getWeekKey(date) {
            const d = new Date(date);
            const dayOfWeek = d.getDay();
            const diff = d.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
            const monday = new Date(d.setDate(diff));
            return `${monday.getFullYear()}-${monday.getMonth()}-${monday.getDate()}`;
        }

        // Use bookingCreateDate from parent state
        const bookingDate = bookingCreateDate;
        const weekKey = bookingDate ? getWeekKey(bookingDate) : null;
        const bookingDateStr = bookingDate ? new Date(bookingDate).toISOString().slice(0, 10) : "";

        // Find booking for modal from weekData first, fallback to bookingSpotData
        const bookingForModal =
            (weekKey && weekData && weekData[weekKey] && weekData[weekKey].find(
                (booking) => booking.BookingDate === bookingDateStr
            )) ||
            bookingSpotData.find(
                (booking) => booking.BookingDate === bookingDateStr
            );

        // Display helpers
        const displayDay = bookingDate ? new Date(bookingDate).getDate() : '';
        const displayMonth = bookingDate ? new Date(bookingDate).toLocaleDateString('en-US', { month: 'long' }) : '';
        const displayYear = bookingDate ? new Date(bookingDate).getFullYear() : '';
        return (
            <div>
                <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
                    id="dateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered modal-custom-width">
                        <div className="modal-content modal-radius">
                            <div className="modal-body">
                                <div className="close-modal">
                                    <a onClick={onClose}>
                                        <img src={Close} aria-label="Close" />
                                    </a>
                                </div>
                                <div className="pt-4">
                                    <h5 className="popup-title">You are in the Queue</h5>
                                </div>
                                <div className="date-with-credit d-flex align-items-center justify-content-between pt-2">
                                    <div id="selectedDate" className="selected-current-date">
                                        <span>{selectedDay}</span>
                                        <span>{displayMonth} &nbsp; {displayYear}</span>
                                    </div>
                                    <div className="credit-info">
                                        {creditInfoJSX}
                                    </div>
                                </div>
                                <div className="divider-line mt-3"></div>
                                <div className="text-center my-34">
                                    <img src={Deskbooking} className="img-fluid" alt="Desk Booking" />
                                </div>

                                {
                                    (() => {
                                        if (!bookingForModal) return null;
                                        // Both Desk and Meeting Room available
                                        if (isQueue === 1 && bookingForModal.JoinedQueue === 1) {
                                            return (
                                                <>
                                                    <div className="mb-4">
                                                        <a
                                                            onClick={() => GotoMapClick(zoneId, bookingDateStr)}
                                                            href="#" className="green-outline-with-icon w-100 mw-100 min-height-56 selected">
                                                            <img src={GreenMap} alt="Map" /><span>Go to map</span>
                                                        </a>
                                                    </div>
                                                    <div className='mb-3'>
                                                        <a
                                                            onClick={() => LeaveQueueModal(zoneId, bookingDateStr)}
                                                            href="#" className="green-outline-with-icon w-100 mw-100 min-height-56 selected">
                                                            <img src={GreenMap} alt="Map" /><span>Leave the queue</span>
                                                        </a>
                                                    </div>
                                                </>
                                            );
                                        }
                                        return null;
                                    })()
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    function GotoMapClick(zoneId, bookingDateStr) {
        console.log("GotoMapClick() clicked", mapAvailableType);
        if (mapAvailableType === 2) {
            window.location.href = `/mapcanvas?zoneId=${encodeURIComponent(zoneId)}&bookingDate=${encodeURIComponent(bookingDateStr)}`;
        } else if (mapAvailableType === 3) {
            window.location.href = `/mapcanvas?zoneId=${encodeURIComponent(zoneId)}&bookingDate=${encodeURIComponent(bookingDateStr)}`;
        } else {
            window.location.href = `/no-map-available?zoneId=${zoneId}`;
        }
    }

    const Calendar_APIforBooking = useCallback(
        async (bookingDateStr, zoneId) => {
            try {
                console.log("Calendar_APIforBooking()", zoneId, "=zoneId", bookingDateStr, "=bookingDateStr");

                await performCalendarApiCall(bookingDateStr, zoneId, null);

                console.log("Calendar refreshed successfully.");
            } catch (err) {
                console.error("Error refreshing calendar:", err);
            }
        },
        [performCalendarApiCall]
    );

    const GetRandomSpace = async (zoneId, bookingDateStr) => {
        try {
            setLoadingDates((prev) => [...prev, bookingDateStr]);
            console.log(setLoadingDates, "GETRANDOMSPACE()loadingDates");

            const response = await MakeBooking_API(zoneId, bookingDateStr);
            console.log("MakeBooking_api())", response);

            if (response && response.Data?.ResponseCode === 200) {
                await new Promise((resolve) => setTimeout(resolve, timeOutTime));

                await Calendar_APIforBooking(bookingDateStr, zoneId);
            } else {
                console.error("Booking failed:", response?.Data?.ResponseMessage);
            }
        } catch (error) {
            console.error("Error calling GetRandomSpace:", error);
        } finally {
            setLoadingDates((prev) => prev.filter((d) => d !== bookingDateStr));
        }
    };

    async function CancelBooking(zoneId, bookingDateStr, cancelBookingSpotId) {
        console.log(
            `Cancel Booking Clicked: ZoneId=${zoneId}, BookingDate=${bookingDateStr}, SpotId=${cancelBookingSpotId}`
        );
        try {
            setLoadingDates((prev) => [...prev, bookingDateStr]);
            const response = await CancelBooking_API(zoneId, bookingDateStr, cancelBookingSpotId);
            console.log("CancelBooking_api response:", response);

            if (response && response.Data?.ResponseCode === 200) {
                await new Promise((resolve) => setTimeout(resolve, timeOutTime));

                await Calendar_APIforBooking(bookingDateStr, zoneId);
            } else {
                console.error("Cancel booking failed:", response?.Data?.ResponseMessage);
            }
        } catch (error) {
            console.error("Error calling CancelBooking_api:", error);
        } finally {
            setLoadingDates((prev) => prev.filter((d) => d !== bookingDateStr));
        }
    }

    const ScheduleMeetingModal = ({ onClose }) => {
        const handleSubmit = () => {
            console.log("Meeting scheduled!");
            onClose(); // Close the popup after submission
        };

        return (
            <div className="modal newmeetingpopup" style={{ display: 'block', backgroundColor: 'rgba(232, 232, 232, 0.)' }}>
                <div className="modal-dialog modal-dialog-centered modal-custom-width">
                    <div className="modal-content modal-radius">
                        <div className="modal-body">
                            <div className="close-modal">
                                <a onClick={onClose}>
                                    <img src={Close} aria-label="Close" />
                                </a>
                            </div>
                            <div className="pt-4">
                                <h5 className="popup-title">Schedule Meeting...</h5>
                            </div>
                            {/* <div className="divider-line mt-3"></div>
                            <div className="form-group">
                                <label htmlFor="meetingTitle">Meeting Title</label>
                                <input
                                    type="text"
                                    id="meetingTitle"
                                    className="form-control"
                                    placeholder="Enter meeting title"
                                />
                            </div>
                            <div className="form-group mt-3">
                                <label htmlFor="meetingDate">Meeting Date</label>
                                <input
                                    type="date"
                                    id="meetingDate"
                                    className="form-control"
                                />
                            </div>
                            <div className="mt-4">
                                <button
                                    className="main-btn outline-green-btn w-100"
                                    onClick={handleSubmit}
                                >
                                    Confirm Meeting
                                </button>
                            </div> */}
                            {/* <div className="modal-des"> */}
                            <form>
                                <div className="form-row">
                                    <label className="popup-inner-title m-0" for="datepicker-calender"> Date </label>
                                    <div className="booking-date"><input type="" id="datepicker-calender" autocomplete="off" /></div>
                                </div>
                                <div className="form-row">
                                    <label className="popup-inner-title m-0" for=""> Spot </label>
                                    <input type="text" className="form-control" autocomplete="off" placeholder="Galway room" />
                                </div>
                                <div className="form-row">
                                    <label className="popup-inner-title m-0" for="time-slot"> Preview Time slot</label>
                                    <div id="timegridview"></div>
                                </div>
                                {/* <div className="form-row">
                                                                <label className="popup-inner-title m-0">Add employee</label>
                                                                <div className="custom-dropdown green-icon-drop-down mb-3">
                                                                    <select className="ctm-select">
                                                                        <option selected>Open this select menu</option>
                                                                        <option value="1">Option One</option>
                                                                        <option value="2">Option Two</option>
                                                                        <option value="3">Option Three</option>
                                                                        <option value="4">Option Four</option>
                                                                    </select>
                                                                </div>
                                                            </div> */}
                                <div className="modal-btn my-4">
                                    <a href="#" className="main-btn outline-green-btn">
                                        <span><img src={PlusButton} alt="plus" /></span>
                                        Add External Guest
                                    </a>
                                </div>
                                <div className="form-row">
                                    <label className="popup-inner-title m-0" for="name"> Name </label>
                                    <input type="text" className="form-control" autocomplete="off" placeholder="Name" />
                                </div>
                                <div className="form-row">
                                    <label className="popup-inner-title m-0" for="surname"> Surname </label>
                                    <input type="text" className="form-control" autocomplete="off" placeholder="Surname" />
                                </div>
                                <div className="form-row">
                                    <label className="popup-inner-title m-0" for="email"> Email </label>
                                    <input type="text" className="form-control" autocomplete="off" placeholder="info@" />
                                    {/* <img src="assets/images/icons/modal-email.svg" className="form-icon" /> */}
                                </div>
                                {/* <div className="modal-btn">
                                                                <a href="#" className="main-btn outline-green-btn">
                                                                     
                                                                     Confirm EXTERNAL GUEST Button
                                                                     </a>
                                                            </div> */}
                                <div className="form-row participants-list">
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" />
                                        <label className="form-check-label" for="inlineCheckbox1">Andrea Martinez (andi234556@gmail.com)</label>
                                        <a href="#"><img src={Deleteicon} className="img-fluid" atl="delete" /></a>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" id="inlineCheckbox2" value="option2" />
                                        <label className="form-check-label" for="inlineCheckbox2">Name Surname (namesurname@gmail.com)</label>
                                        <a href="#"><img src={Deleteicon} className="img-fluid" atl="delete" /></a>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div>
            <div className="content-area">
                <header className="header">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-md-2">
                                <div className="greeting-title">
                                    <p>{headerTitle}</p>
                                </div>
                            </div>
                            <div className="col-md-8">
                                <form action="" className="d-flex justify-content-center custom-inline-dropdown gap-3">
                                    {/* <div className="dropdown form-input-container d-flex justify-content-center flex-column header-dropdown">
                                        <button className="dropdown-toggle form-control position-relative custom-dropdown-btn" type="button" id="desk-dropdown-btn" data-bs-toggle="dropdown" aria-expanded="false" name="deskdropdown" required>
                                            <span>Desk</span>
                                        </button>
                                        <ul className="dropdown-menu custom-dropdown" aria-labelledby="desk-dropdown" id="desk-dropdown">
                                            <li className="selected"><a className="dropdown-item" href="javascript:void(0);">Meeting room</a></li>
                                            <li><a className="dropdown-item" href="javascript:void(0);">Desk</a></li>
                                            <li><a className="dropdown-item" href="javascript:void(0);">Parking</a></li>
                                            <li><a className="dropdown-item" href="javascript:void(0);">Assets</a></li>
                                        </ul>
                                    </div> */}
                                    {/* <div className="dropdown form-input-container d-flex justify-content-center flex-column"> */}

                                    {/* <div className="col-xl-9 offset-xl-3 col-lg-10 offset-lg-2"> */}
                                    <div className="filter-panel d-flex justify-content-end align-items-center gap-3">
                                        <div className="filter-options d-flex gap-3 w-100">
                                            <div className="filter-icon" data-bs-toggle="modal" data-bs-target="#filterPopup">
                                                <img src={filterIcon} alt="" />
                                            </div>

                                            <div
                                                ref={rootRef}
                                                // className="custom-dropdown green-icon-drop-down header-dropdown"
                                                className="employee-list location-list"
                                                onClick={(e) => e.stopPropagation()}
                                                style={{ position: "relative", overflow: "visible", zIndex: 1 }}
                                                label="Zone"
                                            >
                                                <div
                                                    role="button"
                                                    onClick={toggle}
                                                    className="dropdown-toggle form-control position-relative custom-dropdown-btn ctm-select"
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                                        <p className='sub-dropdown-name'>Zone</p>
                                                        <span style={{ fontSize: "16px", fontWeight: "bold", color: "#1c988a" }}>
                                                            {zoneList?.find((z) => z.Id === selectedCalendarZoneId)?.ZoneName ||
                                                                "-- Select a Zone --"}
                                                        </span>
                                                    </div>
                                                    {/* <span>
                                                            {zoneList?.find((z) => z.Id === selectedCalendarZoneId)?.ZoneName ||
                                                                "-- Select a Zone --"}
                                                        </span> */}
                                                    {/* <span>{open ? "▴" : "▾"}</span> */}
                                                </div>

                                                {open && (
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            top: "calc(100% + 6px)",
                                                            left: "auto",
                                                            right: "auto",
                                                            zIndex: 10000,
                                                            background: "#fff",
                                                            border: "1px solid rgba(0,0,0,.08)",
                                                            borderRadius: 12,
                                                            boxShadow: "0 10px 30px rgba(0,0,0,.15)",
                                                            maxHeight: 510,
                                                            overflowY: "auto",
                                                            width: "100%"
                                                        }}
                                                    >
                                                        {zoneList?.length > 0 ? (
                                                            zoneList.map((zone) => (
                                                                <div
                                                                    key={zone.GuId}
                                                                    onClick={() => onSelect(zone)}
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        gap: 8,
                                                                        padding: "8px 12px",
                                                                        cursor: "pointer",
                                                                        whiteSpace: "nowrap",
                                                                        fontFamily: "var(--font-roboto)",
                                                                        fontSize: "12px",
                                                                        lineHeight: "24px",
                                                                        fontWeight: "400",
                                                                    }}
                                                                >
                                                                    <input
                                                                        type="radio"
                                                                        name="areadropdown"
                                                                        value={zone.Id}
                                                                        checked={selectedCalendarZoneId === zone.Id}
                                                                        readOnly
                                                                        style={{
                                                                            marginRight: 8,
                                                                            accentColor: selectedCalendarZoneId === zone.Id ? "#1c988a" : "initial"
                                                                        }}
                                                                    />
                                                                    <span
                                                                        style={{
                                                                            overflow: "hidden",
                                                                            textOverflow: "ellipsis",
                                                                        }}
                                                                    >
                                                                        {zone.ZoneName}
                                                                    </span>
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <div style={{ padding: "8px 12px", color: "#9ca3af" }}>
                                                                {selectedZoneName}
                                                            </div>
                                                        )}

                                                    </div>
                                                )}
                                            </div>
                                            <div className="employee-list">
                                                <div className="dropdown form-input-container d-flex justify-content-center flex-column">
                                                    <Dropdown
                                                        dropdownBtnId="emp-dropdown-btn"
                                                        items={employeeOptions}
                                                        // defaultText="Michael Fureyjj"
                                                        label="Book for"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* </div> */}

                                    <div className="calendar-switcher justify-content-start w-auto">
                                        <input
                                            type="checkbox"
                                            checked={!isMonthly}
                                            className="toggle"
                                            id="toggle"
                                            onChange={() => setIsMonthly(!isMonthly)}
                                        />
                                        <label htmlFor="toggle">
                                            <span
                                                // className={isMonthly ? "on" : ""}
                                                className='on'
                                                id="switch-to-month"
                                                onClick={() => setIsMonthly(true)}
                                            >
                                                Monthly
                                            </span>
                                            <span
                                                className={isMonthly ? "" : "off"}
                                                id="switch-to-week"
                                                onClick={() => setIsMonthly(false)}
                                            >
                                                Weekly
                                            </span>
                                        </label>
                                    </div>
                                </form>
                            </div>

                            <div className="col-md-2">
                                <div className="menu-bar-options d-flex justify-content-end gap-3">
                                    <div className="credit-info">

                                        <a href="#" className="orange-outline-with-icon flex-column">
                                            <img src={OrangeStar} alt="" />
                                            <span className='d-block'>10.5</span>
                                            {/* Conditionally render the span with UserzoneCreditBalance */}
                                            {/* {userZoneCreditValue !== "0" ? (
                                                <span>{UserzoneCreditBalance}</span>
                                            ) : null} */}
                                        </a>
                                        <div className="credit-info-inner text-center">
                                            <div className="profile-info-inner">
                                                <div className="profile-img">
                                                    <img src={Profile} alt="" className="img-fluid" />
                                                </div>
                                                <div className="profile-name">
                                                    <h5>{UserFirstName}</h5>
                                                </div>
                                                <div className="profile-location d-flex justify-content-center align-items-center">
                                                    <img src={ProfileLocation} alt="" />
                                                    <p>Galway.IE</p>
                                                </div>
                                            </div>
                                            <div className="credit-balance-info">
                                                <div className="credit-balance d-flex justify-content-between align-items-center">
                                                    <p>Credit balance</p>
                                                    <h6>14</h6>
                                                </div>
                                                <div className="credit-balance-btn">The credit balance reset <a href="#"> every month </a></div>
                                            </div>
                                            <div className="credit-details-lists">
                                                <div className="list-card">
                                                    <img src={FillStar} alt="" className="img-fluid" />
                                                    <p>Use credits to book spaces</p>
                                                </div>
                                                <div className="list-card">
                                                    <img src={GrayStar} alt="" className="img-fluid" />
                                                    <p>Same day, no credits needed</p>
                                                </div>
                                                <div className="list-card">
                                                    <img src={BlackClose} alt="" className="img-fluid" />
                                                    <p>Release booking for refund</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="notification-info">
                                        <a href="#" data-bs-toggle="offcanvas"
                                            data-bs-target="#notification-panel"
                                            aria-controls="notification-panel"
                                            className="position-relative notification-icon">
                                            <img src={notification} alt="" />
                                            <span className="orange-dot">
                                            </span>
                                        </a>
                                        {/* <NotificationPanel /> */}
                                    </div>
                                    <div className="profile-info">
                                        <div className="dropdown dropdwon-green">
                                            <a href="#" className="profileImg" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                                <img src={profileImg} alt="" />
                                            </a>

                                            {/* <ul className="dropdown-menu profile-dropdown" aria-labelledby="dropdownMenuButton1">
                                                <li>
                                                    <a className="dropdown-item" href="#"
                                                    ><span className="withIcon"><img src={edit} alt="" /></span><span className="withTitle">Settings</span></a>
                                                </li>
                                            </ul> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
                <div className="component-area">
                    {isLoading && (
                        <div id='preloader'>

                            <img src={LoaderFull} alt="" />
                        </div>
                    )}
                    <Sidebar />
                    <div className="pt-96 my-container active-cont">
                        <div className="container">
                            {/* <HeaderFilter /> */}
                            <div ref={setCalendarEl}>
                                <div className="p-4 relative">

                                    <FullCalendar
                                        plugins={[dayGridPlugin, interactionPlugin]}
                                        initialView="dayGridMonth"
                                        firstDay={1}
                                        eventClick={handleEventClick}
                                        customButtons={{
                                            checkInBtn: {
                                                text: 'Check In',
                                                click: handleCheckInButtonClick,
                                                classNames: ['my-custom-button'],
                                            },
                                        }}
                                        headerToolbar={{ left: 'checkInBtn', center: 'prev,title,next', right: false }}
                                        viewDidMount={handleViewMount}
                                        datesSet={handleDatesSet}
                                        dateClick={handleDateClick}
                                        dayCellContent={renderDayCellContent}
                                        customDataVersion={calendarRenderKey}


                                        // plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                                        // headerToolbar={{
                                        //     left: "prev,next today",
                                        //     right: "dayGridMonth,customWeek",
                                        // }}
                                        // views={{
                                        //     customWeek: {
                                        //         type: "timeGrid",
                                        //         buttonText: "Week",
                                        //         visibleRange() {
                                        //           const start = new Date()
                                        //           const end = new Date(start.getTime() + 6 * 24 * 60 * 60 * 1000);

                                        //           return { start, end };
                                        //         },
                                        //     },
                                        // }}
                                        // dayHeaderFormat={{ weekday: "short", day: "numeric" }}
                                    />

                                    {/* <FullCalendar
                                        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                                        headerToolbar={{
                                            left: "prev,next today",
                                            right: "dayGridMonth,customWeek,timeGridDay",
                                        }}

                                        initialView="dayGridMonth"
                                         firstDay={1}

                                        // key={selectedDate ? selectedDate.toISOString().split("T")[0] : "calendar"}
                                        // ref={calendarRef}
                                        views={{
                                            customWeek: {
                                                type: "timeGrid",
                                                buttonText: "Week",
                                                // visibleRange(currentDate) {
                                                //   const start = selectedDateRef.current;
                                                //   const end = new Date(start.getTime() + 6 * 24 * 60 * 60 * 1000);

                                                //   return { start, end };
                                                // },
                                            },
                                        }}

                                        height="auto"
                                        
                                        selectable={true}
                                        editable={true}
                                        nowIndicator={true}
                                        events={events}
                                        eventClick={handleEventClick}
                                        
                                        // sele.ct={handleDateSelect}
                                        // initialDate={selectedDate}
                                        // slotMaxTime={slotMaxTime}
                                        // slotMinTime={slotMinTime}
                                        // dayHeaderFormat={{ weekday: "short", day: "numeric" }}
                                    /> */}
 
                                </div>
                            </div>
                            {/* Modals */}
                            {showBookingModal && (
                                <BookingModal
                                    date={selectedBookingDate}
                                    onClose={() => setShowBookingModal(false)}
                                    zoneId={selectedCalendarZoneId}
                                />
                            )}
                            {showCancelModal && (
                                <CancellationModal
                                    date={selectedCancelDate}
                                    onClose={() => setShowCancelModal(false)}
                                    zoneId={selectedCalendarZoneId}
                                    cancelBookingSpotId={cancelBookingSpotId}
                                />
                            )}
                            {showScheduleMeetingModal && (
                                <ScheduleMeetingModal
                                    onClose={() => setShowScheduleMeetingModal(false)}
                                    zoneId={selectedCalendarZoneId}
                                />
                            )}
                            {showJoinQueueModal && (
                                <JoinQueueModal
                                    date={joinQueueDate}
                                    onClose={() => setShowJoinQueueModal(false)}
                                    zoneId={selectedCalendarZoneId}
                                />
                            )}
                            {showLeaveQueueModal && (
                                <LeaveQueueModal
                                    date={leaveQueueDate}
                                    onClose={() => setShowLeaveQueueModal(false)}
                                    zoneId={selectedCalendarZoneId}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className="modal fade" id="dateModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-custom-width">
                    <div className="modal-content modal-radius">
                        <div className="modal-body">
                            <div className="close-modal">
                                <img src={Close} alt="Close" data-bs-dismiss="modal" aria-label="Close" />
                            </div>
                            <div className="pt-4">
                                <h5 className="popup-title">New Booking</h5>
                            </div>
                            <div className="date-with-credit d-flex align-items-center justify-content-between pt-2">
                                <div id="selectedDate" className="selected-current-date">
                                    {selectedDate}
                                </div>
                                <div className="credit-info">
                                    <a href="#" className="orange-outline-with-icon">
                                        <img src={OrangeStar} alt="Star" /><span>-1</span>
                                    </a>
                                </div>
                            </div>
                            <div className="divider-line mt-3"></div>
                            <div className="mb-4">
                                <a href="#" className="green-outline-with-icon w-100 mw-100 min-height-56 selected">
                                    <img src={GreenMap} alt="Map" /><span>Go to Map</span>
                                </a>
                            </div>
                            <div className="">
                                <a href="#" className="green-outline-with-icon w-100 mw-100 min-height-56">
                                    <img src={EditSquare} alt="Edit" /><span>Get Random Space</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

            {/* Check In Button */}
            {
                showModal && (
                    <div
                        className="modal fade show d-block"
                        id="checkinModal"
                        tabIndex="-1"
                        aria-labelledby="checkinModalLabel"
                        aria-hidden="true"
                        style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
                    >
                        <div className="modal-dialog modal-dialog-centered modal-custom-width">
                            <div className="modal-content modal-radius">
                                <div className="modal-body">
                                    <div className="close-modal">
                                        <img
                                            src={Close}
                                            alt=""
                                            onClick={closeModal}
                                            aria-label="Close"
                                            style={{ cursor: 'pointer' }}
                                        />
                                    </div>
                                    <div className="pt-4">
                                        <h5 className="popup-title">Your Check In</h5>
                                    </div>
                                    <div className="date-with-credit d-flex align-items-center gap-4 pt-2 position-relative">
                                        <div id="date" className="current-date">
                                            {/* <h5>{formattedDate}</h5> */}
                                            <h5>{formattedOnlyDate}</h5>
                                            <h5>{formattedOnlyMonthShort}</h5>
                                        </div>
                                        <div className="location-info">
                                            <img
                                                src={MapOrange}
                                                className="img-fluid"
                                                alt=""
                                            />
                                            <p>Dublin Office Ground Floor</p>
                                        </div>
                                    </div>
                                    <div className="checkin-info">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>Spot</th>
                                                    <th>Time</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {events.map((event) => (
                                                    <tr key={event.id}>
                                                        <td>{event.title.split(' - ')[0]}</td>
                                                        <td>{event.title.split(' - ')[1]}</td>
                                                        <td>
                                                            <button
                                                                type="button"
                                                                title={event.status === 'available' ? 'Check In' : 'Check Out'}
                                                                aria-pressed={event.status === 'checked-in'}
                                                                className={`fc-checkInBtn-button fc-button fc-button-primary ${event.status}`}
                                                                onClick={() => handleEventClick({ event })}
                                                            >
                                                                {event.status === 'available' ? 'Check In' : 'Check Out'}
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="mb-4">
                                        <a
                                            href="#"
                                            className="green-outline-with-icon w-100 mw-100 min-height-56 selected"
                                        >
                                            <img src="assets/images/icons/green-map.svg" alt="" />
                                            <span>Go to Map</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
            {/* <TeamsComponent /> */}
            <Responsive />
        </div>
    )
}

// Define the CSS for the selected day content
const styles = `
    .fc-day-content .my-selected-day-content {
        background-color: #008080; /* Your desired green color */
        color: white; /* Optional: text color */
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%; /* Ensure it fills the cell */
    }
`;
const CalendarWithStyles = (props) => (
    <>
        <style>{styles}</style>
        <Calendar {...props} />
    </>
);

export default CalendarWithStyles;

function Dropdown({ dropdownId, items, label }) {
    const [selectedItem, setSelectedItem] = useState(items[0]);

    const handleItemClick = (item) => {
        setSelectedItem(item);
    };

    return (
        <div className="employee-list">
            <div className="dropdown form-input-container d-flex justify-content-center flex-column">
                <button
                    className="dropdown-toggle form-control position-relative custom-dropdown-btn"
                    type="button"
                    id={dropdownId}
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    name="empdropdown"
                    required
                >
                    <p className="sub-dropdown-name">{label}</p>
                    <span>{selectedItem}</span>
                </button>
                <ul className="dropdown-menu custom-dropdown" aria-labelledby={dropdownId}>
                    {items.map((item, index) => (
                        <li
                            key={index}
                            className={item === selectedItem ? "selected" : ""}
                            onClick={() => handleItemClick(item)}
                        >
                            <a className="dropdown-item">
                                {item}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
            <Responsive />
        </div>
    );
}
